import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const StatusTerminal = param => {
  let status;
  switch (param) {
    case '1':
      status = <div className="text-success">En linea</div>;
      break;
    case '3':
      status = <div className="text-danger">Fuera de linea</div>;
      break;
    default:
      break;
  }
  return status;
};

const ControlClockShow = ({ data }) => {
  const { companies: dataCompanies, company: dataCompany, branch_office: dataBranchOffice } = data || {};
  let companies = [];
  if (dataCompanies && dataCompanies.length > 0) {
    companies = dataCompanies;
  } else if (dataCompany) {
    companies = [
      {
        id: dataCompany.id,
        business_name: dataCompany.business_name,
        branch_office: dataBranchOffice
      }
    ];
  }

  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col md={12}>
              <div className="info">
                <span className="type">Serial:</span>
                <span className="align-right" />
                <span className="answer"> {data.sn}</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="info">
                <span className="type">Alias:</span>
                <span className="align-right" />
                <span className="answer"> {data.alias}</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="info">
                <span className="type">Dirección IP:</span>
                <span className="align-right" />
                <span className="answer"> {data.ip_address}</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="info">
                <span className="type">Estado del Registro:</span>
                <span className="align-right" />
                <span className={data.active ? 'answer text-success' : 'answer text-danger'}>
                  {data.active ? 'Activo' : 'Inactivo'}
                </span>
              </div>
            </Col>
            {data.details && (
              <>
                <Col md={12}>
                  <div className="info">
                    <span className="type">Estado del Terminal:</span>
                    <span className="align-right" />
                    <span className="answer"> {StatusTerminal(data.details.state)}</span>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="info">
                    <span className="type">Ultima Actividad:</span>
                    <span className="align-right" />
                    <span className="answer"> {data.details.last_activity}</span>
                  </div>
                </Col>
              </>
            )}
          </Row>

          <hr className="my-3" />
          <h6 className="font-weight-bold mb-3 text-uppercase">
            {companies.length > 1 ? `Empresas Asociadas (${companies.length})` : 'Empresa Asociada'}
          </h6>

          {companies.map(comp => (
            <div
              key={`comp-show-${comp.id || comp.company_id || comp.business_name}`}
              className="p-3 mb-2 bg-light rounded border"
            >
              <Row>
                <Col md={6}>
                  <div className="info mb-1">
                    <span className="type font-weight-bold">Empresa:</span>
                    <span className="answer"> {comp.business_name || '-'}</span>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="info mb-1">
                    <span className="type font-weight-bold">Lugar de Prestación:</span>
                    <span className="answer"> {comp.branch_office?.name || comp.branch_office_name || '-'}</span>
                  </div>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      </Card>
    </>
  );
};

export default ControlClockShow;